import { Alert } from "@mui/material"
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';
import { ProducerDashboard } from "../interfaces/ProducerDashboard";
import { lmwApiError } from "./ProducerDashboardHelper";

type ApiErrorAlertProps = {
    data: ProducerDashboard
}

export const ApiErrorAlert = ({ data }: ApiErrorAlertProps) => {
    const errors = lmwApiError(data);
    return (
        <Alert severity="error" variant="filled" icon={<GppBadOutlinedIcon fontSize="inherit" />}>
           API Error - Can't retrieve from Lemonway :  <strong>{errors}</strong> 
        </Alert>
    )
}